// this file is generated from the shared currencies tsv file, do not modify

import type { Currency } from "@/models/currency";

type DistinctPair<T> =
  T extends `${infer Ccy1}/${infer Ccy2}`
    ? [Ccy1, Ccy2] extends [Ccy2, Ccy1]
      ? T
      : `${Ccy1}/${Ccy2}`
    : T

export type CurrencyPairName = DistinctPair<`${Currency}/${Currency}`>

interface CurrencyPairBase<T> {
  pair: T;
  precision: number;
  isInverted: boolean;
  canOption: boolean;
}

export type CurrencyPair = CurrencyPairBase<CurrencyPairName>

type CurrencyPairMap = {
  [K in CurrencyPairName]?: CurrencyPairBase<K>
};

export const currencies: CurrencyPairMap = {
  'AED/CAD': {
    pair: 'AED/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/CHF': {
    pair: 'AED/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/CNH': {
    pair: 'AED/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AED/EUR': {
    pair: 'AED/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/GBP': {
    pair: 'AED/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/HKD': {
    pair: 'AED/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AED/JPY': {
    pair: 'AED/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AED/NOK': {
    pair: 'AED/NOK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AED/PLN': {
    pair: 'AED/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AED/SAR': {
    pair: 'AED/SAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/SEK': {
    pair: 'AED/SEK',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'AED/SGD': {
    pair: 'AED/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AED/USD': {
    pair: 'AED/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/AUD': {
    pair: 'ARS/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/CAD': {
    pair: 'ARS/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/CHF': {
    pair: 'ARS/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/DKK': {
    pair: 'ARS/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/EUR': {
    pair: 'ARS/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/GBP': {
    pair: 'ARS/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/HUF': {
    pair: 'ARS/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ARS/JPY': {
    pair: 'ARS/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ARS/NOK': {
    pair: 'ARS/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/NZD': {
    pair: 'ARS/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/SEK': {
    pair: 'ARS/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ARS/USD': {
    pair: 'ARS/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AUD/AED': {
    pair: 'AUD/AED',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'AUD/ARS': {
    pair: 'AUD/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/BRL': {
    pair: 'AUD/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/CAD': {
    pair: 'AUD/CAD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/CHF': {
    pair: 'AUD/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/CLP': {
    pair: 'AUD/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/CNH': {
    pair: 'AUD/CNH',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/CNY': {
    pair: 'AUD/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/COP': {
    pair: 'AUD/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'AUD/CZK': {
    pair: 'AUD/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/DKK': {
    pair: 'AUD/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/EGP': {
    pair: 'AUD/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/EUR': {
    pair: 'AUD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'AUD/GBP': {
    pair: 'AUD/GBP',
    precision: 5,
    isInverted: true,
    canOption: true,
  },
  'AUD/HKD': {
    pair: 'AUD/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/HUF': {
    pair: 'AUD/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/IDR': {
    pair: 'AUD/IDR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'AUD/ILS': {
    pair: 'AUD/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/INR': {
    pair: 'AUD/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/JPY': {
    pair: 'AUD/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'AUD/KES': {
    pair: 'AUD/KES',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'AUD/KRW': {
    pair: 'AUD/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'AUD/KZT': {
    pair: 'AUD/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/MAD': {
    pair: 'AUD/MAD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'AUD/MXN': {
    pair: 'AUD/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/NGN': {
    pair: 'AUD/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/NOK': {
    pair: 'AUD/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/NZD': {
    pair: 'AUD/NZD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/PEN': {
    pair: 'AUD/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/PHP': {
    pair: 'AUD/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/PLN': {
    pair: 'AUD/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/RUB': {
    pair: 'AUD/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/SEK': {
    pair: 'AUD/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/SGD': {
    pair: 'AUD/SGD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/THB': {
    pair: 'AUD/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/TRY': {
    pair: 'AUD/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/TWD': {
    pair: 'AUD/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/UAH': {
    pair: 'AUD/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/USD': {
    pair: 'AUD/USD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'AUD/VND': {
    pair: 'AUD/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'AUD/ZAR': {
    pair: 'AUD/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BGN/CHF': {
    pair: 'BGN/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BGN/EUR': {
    pair: 'BGN/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BGN/GBP': {
    pair: 'BGN/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BGN/JPY': {
    pair: 'BGN/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BGN/PLN': {
    pair: 'BGN/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BGN/RON': {
    pair: 'BGN/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BHD/CAD': {
    pair: 'BHD/CAD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'BHD/USD': {
    pair: 'BHD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/AUD': {
    pair: 'BRL/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/CAD': {
    pair: 'BRL/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/CHF': {
    pair: 'BRL/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/CLP': {
    pair: 'BRL/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BRL/CNH': {
    pair: 'BRL/CNH',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'BRL/DKK': {
    pair: 'BRL/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BRL/EUR': {
    pair: 'BRL/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/GBP': {
    pair: 'BRL/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/HUF': {
    pair: 'BRL/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/JPY': {
    pair: 'BRL/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BRL/MXN': {
    pair: 'BRL/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'BRL/NOK': {
    pair: 'BRL/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/NZD': {
    pair: 'BRL/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/SEK': {
    pair: 'BRL/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'BRL/USD': {
    pair: 'BRL/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/AED': {
    pair: 'CAD/AED',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CAD/ARS': {
    pair: 'CAD/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/AUD': {
    pair: 'CAD/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/BGN': {
    pair: 'CAD/BGN',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CAD/BHD': {
    pair: 'CAD/BHD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'CAD/BRL': {
    pair: 'CAD/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/CHF': {
    pair: 'CAD/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'CAD/CLP': {
    pair: 'CAD/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/CNH': {
    pair: 'CAD/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/CNY': {
    pair: 'CAD/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/COP': {
    pair: 'CAD/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CAD/CZK': {
    pair: 'CAD/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/DKK': {
    pair: 'CAD/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/EGP': {
    pair: 'CAD/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/EUR': {
    pair: 'CAD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/GBP': {
    pair: 'CAD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/HKD': {
    pair: 'CAD/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/HUF': {
    pair: 'CAD/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/IDR': {
    pair: 'CAD/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/ILS': {
    pair: 'CAD/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/INR': {
    pair: 'CAD/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/JPY': {
    pair: 'CAD/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'CAD/KWD': {
    pair: 'CAD/KWD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'CAD/QAR': {
    pair: 'CAD/QAR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CAD/KRW': {
    pair: 'CAD/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/KZT': {
    pair: 'CAD/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/MXN': {
    pair: 'CAD/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/NGN': {
    pair: 'CAD/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/NOK': {
    pair: 'CAD/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'CAD/NZD': {
    pair: 'CAD/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/PEN': {
    pair: 'CAD/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/PHP': {
    pair: 'CAD/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/PLN': {
    pair: 'CAD/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/RON': {
    pair: 'CAD/RON',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CAD/RUB': {
    pair: 'CAD/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/SAR': {
    pair: 'CAD/SAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/SEK': {
    pair: 'CAD/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'CAD/SGD': {
    pair: 'CAD/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/THB': {
    pair: 'CAD/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/TRY': {
    pair: 'CAD/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/TWD': {
    pair: 'CAD/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/UAH': {
    pair: 'CAD/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/USD': {
    pair: 'CAD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CAD/VND': {
    pair: 'CAD/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CAD/ZAR': {
    pair: 'CAD/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/AED': {
    pair: 'CHF/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/ARS': {
    pair: 'CHF/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/AUD': {
    pair: 'CHF/AUD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CHF/BGN': {
    pair: 'CHF/BGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/BRL': {
    pair: 'CHF/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/CAD': {
    pair: 'CHF/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CHF/CLP': {
    pair: 'CHF/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/CNH': {
    pair: 'CHF/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/CNY': {
    pair: 'CHF/CNY',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/COP': {
    pair: 'CHF/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/CZK': {
    pair: 'CHF/CZK',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CHF/DKK': {
    pair: 'CHF/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/EGP': {
    pair: 'CHF/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/EUR': {
    pair: 'CHF/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/GBP': {
    pair: 'CHF/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/GHS': {
    pair: 'CHF/GHS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/HKD': {
    pair: 'CHF/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/HRK': {
    pair: 'CHF/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/HUF': {
    pair: 'CHF/HUF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/IDR': {
    pair: 'CHF/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/ILS': {
    pair: 'CHF/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/INR': {
    pair: 'CHF/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/JPY': {
    pair: 'CHF/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'CHF/KES': {
    pair: 'CHF/KES',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/KRW': {
    pair: 'CHF/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/KWD': {
    pair: 'CHF/KWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/KZT': {
    pair: 'CHF/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/MAD': {
    pair: 'CHF/MAD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/MXN': {
    pair: 'CHF/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/NGN': {
    pair: 'CHF/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/NOK': {
    pair: 'CHF/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'CHF/NZD': {
    pair: 'CHF/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/PEN': {
    pair: 'CHF/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/PHP': {
    pair: 'CHF/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/PLN': {
    pair: 'CHF/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/QAR': {
    pair: 'CHF/QAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/RON': {
    pair: 'CHF/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/RSD': {
    pair: 'CHF/RSD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/RUB': {
    pair: 'CHF/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/SAR': {
    pair: 'CHF/SAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/SEK': {
    pair: 'CHF/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'CHF/SGD': {
    pair: 'CHF/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/THB': {
    pair: 'CHF/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/TND': {
    pair: 'CHF/TND',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/TRY': {
    pair: 'CHF/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/TWD': {
    pair: 'CHF/TWD',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CHF/UAH': {
    pair: 'CHF/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/USD': {
    pair: 'CHF/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CHF/VND': {
    pair: 'CHF/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CHF/ZAR': {
    pair: 'CHF/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CLP/AUD': {
    pair: 'CLP/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/CAD': {
    pair: 'CLP/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/CHF': {
    pair: 'CLP/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/DKK': {
    pair: 'CLP/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/EUR': {
    pair: 'CLP/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CLP/GBP': {
    pair: 'CLP/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CLP/HUF': {
    pair: 'CLP/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/JPY': {
    pair: 'CLP/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/NOK': {
    pair: 'CLP/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/NZD': {
    pair: 'CLP/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/SEK': {
    pair: 'CLP/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CLP/USD': {
    pair: 'CLP/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CNH/AED': {
    pair: 'CNH/AED',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/AUD': {
    pair: 'CNH/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/BRL': {
    pair: 'CNH/BRL',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CNH/CAD': {
    pair: 'CNH/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/CHF': {
    pair: 'CNH/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/CZK': {
    pair: 'CNH/CZK',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CNH/DKK': {
    pair: 'CNH/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/EUR': {
    pair: 'CNH/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/GBP': {
    pair: 'CNH/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/HKD': {
    pair: 'CNH/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNH/HUF': {
    pair: 'CNH/HUF',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'CNH/IDR': {
    pair: 'CNH/IDR',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'CNH/INR': {
    pair: 'CNH/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNH/JPY': {
    pair: 'CNH/JPY',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CNH/KRW': {
    pair: 'CNH/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'CNH/MXN': {
    pair: 'CNH/MXN',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CNH/NOK': {
    pair: 'CNH/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/NZD': {
    pair: 'CNH/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/PHP': {
    pair: 'CNH/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNH/PLN': {
    pair: 'CNH/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/RUB': {
    pair: 'CNH/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNH/SAR': {
    pair: 'CNH/SAR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CNH/SEK': {
    pair: 'CNH/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/SGD': {
    pair: 'CNH/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/THB': {
    pair: 'CNH/THB',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'CNH/TWD': {
    pair: 'CNH/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNH/USD': {
    pair: 'CNH/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNH/ZAR': {
    pair: 'CNH/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/AUD': {
    pair: 'CNY/AUD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'CNY/CAD': {
    pair: 'CNY/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/CHF': {
    pair: 'CNY/CHF',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'CNY/DKK': {
    pair: 'CNY/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/EUR': {
    pair: 'CNY/EUR',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'CNY/GBP': {
    pair: 'CNY/GBP',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'CNY/HUF': {
    pair: 'CNY/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/JPY': {
    pair: 'CNY/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CNY/NOK': {
    pair: 'CNY/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/NZD': {
    pair: 'CNY/NZD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'CNY/SEK': {
    pair: 'CNY/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CNY/USD': {
    pair: 'CNY/USD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'COP/AUD': {
    pair: 'COP/AUD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/CAD': {
    pair: 'COP/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/CHF': {
    pair: 'COP/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/DKK': {
    pair: 'COP/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'COP/EUR': {
    pair: 'COP/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/GBP': {
    pair: 'COP/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/HUF': {
    pair: 'COP/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'COP/JPY': {
    pair: 'COP/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'COP/NOK': {
    pair: 'COP/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'COP/NZD': {
    pair: 'COP/NZD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'COP/SEK': {
    pair: 'COP/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'COP/USD': {
    pair: 'COP/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CZK/AUD': {
    pair: 'CZK/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CZK/CHF': {
    pair: 'CZK/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'CZK/DKK': {
    pair: 'CZK/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CZK/EUR': {
    pair: 'CZK/EUR',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'CZK/GBP': {
    pair: 'CZK/GBP',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'CZK/HKD': {
    pair: 'CZK/HKD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CZK/HRK': {
    pair: 'CZK/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CZK/HUF': {
    pair: 'CZK/HUF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CZK/INR': {
    pair: 'CZK/INR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'CZK/JPY': {
    pair: 'CZK/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CZK/NOK': {
    pair: 'CZK/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CZK/PLN': {
    pair: 'CZK/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CZK/RON': {
    pair: 'CZK/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CZK/RUB': {
    pair: 'CZK/RUB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'CZK/SEK': {
    pair: 'CZK/SEK',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'CZK/SGD': {
    pair: 'CZK/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'CZK/USD': {
    pair: 'CZK/USD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'CZK/ZAR': {
    pair: 'CZK/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/ARS': {
    pair: 'DKK/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/AUD': {
    pair: 'DKK/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DKK/BRL': {
    pair: 'DKK/BRL',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DKK/CAD': {
    pair: 'DKK/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'DKK/CHF': {
    pair: 'DKK/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'DKK/CLP': {
    pair: 'DKK/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/CNH': {
    pair: 'DKK/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/CNY': {
    pair: 'DKK/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/COP': {
    pair: 'DKK/COP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/CZK': {
    pair: 'DKK/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/EGP': {
    pair: 'DKK/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/EUR': {
    pair: 'DKK/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'DKK/GBP': {
    pair: 'DKK/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'DKK/HKD': {
    pair: 'DKK/HKD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'DKK/HUF': {
    pair: 'DKK/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/IDR': {
    pair: 'DKK/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/INR': {
    pair: 'DKK/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/JPY': {
    pair: 'DKK/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/KRW': {
    pair: 'DKK/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/KZT': {
    pair: 'DKK/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/NGN': {
    pair: 'DKK/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/NOK': {
    pair: 'DKK/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DKK/NZD': {
    pair: 'DKK/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DKK/PEN': {
    pair: 'DKK/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/PHP': {
    pair: 'DKK/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/PLN': {
    pair: 'DKK/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DKK/RON': {
    pair: 'DKK/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/RUB': {
    pair: 'DKK/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/SEK': {
    pair: 'DKK/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/SGD': {
    pair: 'DKK/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/TRY': {
    pair: 'DKK/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/TWD': {
    pair: 'DKK/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/UAH': {
    pair: 'DKK/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DKK/USD': {
    pair: 'DKK/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'DKK/VND': {
    pair: 'DKK/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'DZD/EUR': {
    pair: 'DZD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'DZD/USD': {
    pair: 'DZD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/AUD': {
    pair: 'EGP/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/CAD': {
    pair: 'EGP/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/CHF': {
    pair: 'EGP/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/DKK': {
    pair: 'EGP/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/EUR': {
    pair: 'EGP/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/GBP': {
    pair: 'EGP/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/HUF': {
    pair: 'EGP/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/JPY': {
    pair: 'EGP/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/NOK': {
    pair: 'EGP/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/NZD': {
    pair: 'EGP/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/SEK': {
    pair: 'EGP/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EGP/USD': {
    pair: 'EGP/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'EUR/AED': {
    pair: 'EUR/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/ARS': {
    pair: 'EUR/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/AUD': {
    pair: 'EUR/AUD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/BGN': {
    pair: 'EUR/BGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/BHD': {
    pair: 'EUR/BHD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'EUR/BRL': {
    pair: 'EUR/BRL',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/CAD': {
    pair: 'EUR/CAD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/CHF': {
    pair: 'EUR/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/CLP': {
    pair: 'EUR/CLP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/CNH': {
    pair: 'EUR/CNH',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/CNY': {
    pair: 'EUR/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/COP': {
    pair: 'EUR/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/CZK': {
    pair: 'EUR/CZK',
    precision: 4,
    isInverted: false,
    canOption: true,
  },
  'EUR/DKK': {
    pair: 'EUR/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/DZD': {
    pair: 'EUR/DZD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/EGP': {
    pair: 'EUR/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/GBP': {
    pair: 'EUR/GBP',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/GHS': {
    pair: 'EUR/GHS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/HKD': {
    pair: 'EUR/HKD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/HRK': {
    pair: 'EUR/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/HUF': {
    pair: 'EUR/HUF',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'EUR/IDR': {
    pair: 'EUR/IDR',
    precision: 1,
    isInverted: false,
    canOption: false,
  },
  'EUR/ILS': {
    pair: 'EUR/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/INR': {
    pair: 'EUR/INR',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'EUR/ISK': {
    pair: 'EUR/ISK',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/JOD': {
    pair: 'EUR/JOD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/JPY': {
    pair: 'EUR/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'EUR/KES': {
    pair: 'EUR/KES',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'EUR/KRW': {
    pair: 'EUR/KRW',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'EUR/KWD': {
    pair: 'EUR/KWD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'EUR/KZT': {
    pair: 'EUR/KZT',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/MAD': {
    pair: 'EUR/MAD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/MUR': {
    pair: 'EUR/MUR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/MXN': {
    pair: 'EUR/MXN',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/MZN': {
    pair: 'EUR/MZN',
    precision: 2,
    isInverted: false,
    canOption: true,
  },
  'EUR/NGN': {
    pair: 'EUR/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/NOK': {
    pair: 'EUR/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/NZD': {
    pair: 'EUR/NZD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/OMR': {
    pair: 'EUR/OMR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/PEN': {
    pair: 'EUR/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/PHP': {
    pair: 'EUR/PHP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/PLN': {
    pair: 'EUR/PLN',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/QAR': {
    pair: 'EUR/QAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/RON': {
    pair: 'EUR/RON',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/RSD': {
    pair: 'EUR/RSD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'EUR/RUB': {
    pair: 'EUR/RUB',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/SAR': {
    pair: 'EUR/SAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/SEK': {
    pair: 'EUR/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/SGD': {
    pair: 'EUR/SGD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/THB': {
    pair: 'EUR/THB',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/TND': {
    pair: 'EUR/TND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/TRY': {
    pair: 'EUR/TRY',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/TWD': {
    pair: 'EUR/TWD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'EUR/UAH': {
    pair: 'EUR/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'EUR/USD': {
    pair: 'EUR/USD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/VND': {
    pair: 'EUR/VND',
    precision: 1,
    isInverted: false,
    canOption: false,
  },
  'EUR/XAF': {
    pair: 'EUR/XAF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'EUR/XOF': {
    pair: 'EUR/XOF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'EUR/ZAR': {
    pair: 'EUR/ZAR',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'EUR/ZMW': {
    pair: 'EUR/ZMW',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'GBP/AED': {
    pair: 'GBP/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/ARS': {
    pair: 'GBP/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/AUD': {
    pair: 'GBP/AUD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/BGN': {
    pair: 'GBP/BGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/BHD': {
    pair: 'GBP/BHD',
    precision: 4,
    isInverted: true,
    canOption: true,
  },
  'GBP/BRL': {
    pair: 'GBP/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/CAD': {
    pair: 'GBP/CAD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/CHF': {
    pair: 'GBP/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/CLP': {
    pair: 'GBP/CLP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/CNH': {
    pair: 'GBP/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/CNY': {
    pair: 'GBP/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/COP': {
    pair: 'GBP/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/CZK': {
    pair: 'GBP/CZK',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/DKK': {
    pair: 'GBP/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/EGP': {
    pair: 'GBP/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/EUR': {
    pair: 'GBP/EUR',
    precision: 5,
    isInverted: true,
    canOption: true,
  },
  'GBP/GHS': {
    pair: 'GBP/GHS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/HKD': {
    pair: 'GBP/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/HRK': {
    pair: 'GBP/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/HUF': {
    pair: 'GBP/HUF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/IDR': {
    pair: 'GBP/IDR',
    precision: 1,
    isInverted: false,
    canOption: false,
  },
  'GBP/ILS': {
    pair: 'GBP/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/INR': {
    pair: 'GBP/INR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/JPY': {
    pair: 'GBP/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'GBP/KES': {
    pair: 'GBP/KES',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'GBP/KWD': {
    pair: 'GBP/KWD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'GBP/KRW': {
    pair: 'GBP/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/KZT': {
    pair: 'GBP/KZT',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/MAD': {
    pair: 'GBP/MAD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/MXN': {
    pair: 'GBP/MXN',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'GBP/NGN': {
    pair: 'GBP/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/NOK': {
    pair: 'GBP/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/NZD': {
    pair: 'GBP/NZD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/PEN': {
    pair: 'GBP/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/PHP': {
    pair: 'GBP/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/PLN': {
    pair: 'GBP/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/QAR': {
    pair: 'GBP/QAR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'GBP/RON': {
    pair: 'GBP/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/RUB': {
    pair: 'GBP/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/SAR': {
    pair: 'GBP/SAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/SEK': {
    pair: 'GBP/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/SGD': {
    pair: 'GBP/SGD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/THB': {
    pair: 'GBP/THB',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'GBP/TND': {
    pair: 'GBP/TND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/TRY': {
    pair: 'GBP/TRY',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'GBP/TWD': {
    pair: 'GBP/TWD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'GBP/UAH': {
    pair: 'GBP/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GBP/USD': {
    pair: 'GBP/USD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'GBP/VND': {
    pair: 'GBP/VND',
    precision: 1,
    isInverted: false,
    canOption: false,
  },
  'GBP/XAF': {
    pair: 'GBP/XAF',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'GBP/XOF': {
    pair: 'GBP/XOF',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'GBP/ZAR': {
    pair: 'GBP/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'GHS/CHF': {
    pair: 'GHS/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'GHS/EUR': {
    pair: 'GHS/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'GHS/GBP': {
    pair: 'GHS/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'GHS/JPY': {
    pair: 'GHS/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'GHS/USD': {
    pair: 'GHS/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/AOA': {
    pair: 'HKD/AOA',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'HKD/AUD': {
    pair: 'HKD/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/BRL': {
    pair: 'HKD/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/CAD': {
    pair: 'HKD/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/CHF': {
    pair: 'HKD/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/CNH': {
    pair: 'HKD/CNH',
    precision: 5,
    isInverted: true,
    canOption: true,
  },
  'HKD/CNY': {
    pair: 'HKD/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/CZK': {
    pair: 'HKD/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/DKK': {
    pair: 'HKD/DKK',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'HKD/EUR': {
    pair: 'HKD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/GBP': {
    pair: 'HKD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/HUF': {
    pair: 'HKD/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/INR': {
    pair: 'HKD/INR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'HKD/JPY': {
    pair: 'HKD/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/MXN': {
    pair: 'HKD/MXN',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'HKD/KRW': {
    pair: 'HKD/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/KWD': {
    pair: 'HKD/KWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/NOK': {
    pair: 'HKD/NOK',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'HKD/RUB': {
    pair: 'HKD/RUB',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'HKD/NZD': {
    pair: 'HKD/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/PLN': {
    pair: 'HKD/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/SEK': {
    pair: 'HKD/SEK',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'HKD/SGD': {
    pair: 'HKD/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HKD/THB': {
    pair: 'HKD/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HKD/TWD': {
    pair: 'HKD/TWD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'HKD/USD': {
    pair: 'HKD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/CHF': {
    pair: 'HRK/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/CZK': {
    pair: 'HRK/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/EUR': {
    pair: 'HRK/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/GBP': {
    pair: 'HRK/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/HUF': {
    pair: 'HRK/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/JPY': {
    pair: 'HRK/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/PLN': {
    pair: 'HRK/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HRK/USD': {
    pair: 'HRK/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/ARS': {
    pair: 'HUF/ARS',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/AUD': {
    pair: 'HUF/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/BRL': {
    pair: 'HUF/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/CAD': {
    pair: 'HUF/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/CHF': {
    pair: 'HUF/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/CLP': {
    pair: 'HUF/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/CNY': {
    pair: 'HUF/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/COP': {
    pair: 'HUF/COP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/DKK': {
    pair: 'HUF/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/EGP': {
    pair: 'HUF/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/EUR': {
    pair: 'HUF/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/GBP': {
    pair: 'HUF/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/HKD': {
    pair: 'HUF/HKD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/HRK': {
    pair: 'HUF/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/IDR': {
    pair: 'HUF/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/ILS': {
    pair: 'HUF/ILS',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/INR': {
    pair: 'HUF/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/JPY': {
    pair: 'HUF/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/KRW': {
    pair: 'HUF/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/KZT': {
    pair: 'HUF/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/NGN': {
    pair: 'HUF/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/NOK': {
    pair: 'HUF/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/PEN': {
    pair: 'HUF/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/PHP': {
    pair: 'HUF/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/PLN': {
    pair: 'HUF/PLN',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/RON': {
    pair: 'HUF/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/RUB': {
    pair: 'HUF/RUB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/SEK': {
    pair: 'HUF/SEK',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/SGD': {
    pair: 'HUF/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'HUF/TRY': {
    pair: 'HUF/TRY',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/TWD': {
    pair: 'HUF/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/UAH': {
    pair: 'HUF/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/USD': {
    pair: 'HUF/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'HUF/VND': {
    pair: 'HUF/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'HUF/ZAR': {
    pair: 'HUF/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'IDR/AUD': {
    pair: 'IDR/AUD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'IDR/CAD': {
    pair: 'IDR/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'IDR/CHF': {
    pair: 'IDR/CHF',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'IDR/CNH': {
    pair: 'IDR/CNH',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'IDR/DKK': {
    pair: 'IDR/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'IDR/EUR': {
    pair: 'IDR/EUR',
    precision: 10,
    isInverted: true,
    canOption: false,
  },
  'IDR/GBP': {
    pair: 'IDR/GBP',
    precision: 10,
    isInverted: true,
    canOption: false,
  },
  'IDR/HUF': {
    pair: 'IDR/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'IDR/JPY': {
    pair: 'IDR/JPY',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'IDR/NOK': {
    pair: 'IDR/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'IDR/NZD': {
    pair: 'IDR/NZD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'IDR/SEK': {
    pair: 'IDR/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'IDR/USD': {
    pair: 'IDR/USD',
    precision: 10,
    isInverted: true,
    canOption: false,
  },
  'ILS/CAD': {
    pair: 'ILS/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/CHF': {
    pair: 'ILS/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/EUR': {
    pair: 'ILS/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/GBP': {
    pair: 'ILS/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/HUF': {
    pair: 'ILS/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ILS/JPY': {
    pair: 'ILS/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ILS/NZD': {
    pair: 'ILS/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/PLN': {
    pair: 'ILS/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ILS/USD': {
    pair: 'ILS/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/AUD': {
    pair: 'INR/AUD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'INR/CAD': {
    pair: 'INR/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/CHF': {
    pair: 'INR/CHF',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'INR/CNH': {
    pair: 'INR/CNH',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'INR/DKK': {
    pair: 'INR/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/EUR': {
    pair: 'INR/EUR',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'INR/GBP': {
    pair: 'INR/GBP',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'INR/HUF': {
    pair: 'INR/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/JPY': {
    pair: 'INR/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'INR/NOK': {
    pair: 'INR/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/NZD': {
    pair: 'INR/NZD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'INR/SEK': {
    pair: 'INR/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/SGD': {
    pair: 'INR/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'INR/USD': {
    pair: 'INR/USD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'JPY/AED': {
    pair: 'JPY/AED',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/ARS': {
    pair: 'JPY/ARS',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/AUD': {
    pair: 'JPY/AUD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/BGN': {
    pair: 'JPY/BGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/BRL': {
    pair: 'JPY/BRL',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/CAD': {
    pair: 'JPY/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/CHF': {
    pair: 'JPY/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/CLP': {
    pair: 'JPY/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/CNH': {
    pair: 'JPY/CNH',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/CNY': {
    pair: 'JPY/CNY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/COP': {
    pair: 'JPY/COP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/CZK': {
    pair: 'JPY/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/DKK': {
    pair: 'JPY/DKK',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/EGP': {
    pair: 'JPY/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/EUR': {
    pair: 'JPY/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/GBP': {
    pair: 'JPY/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/GHS': {
    pair: 'JPY/GHS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/HKD': {
    pair: 'JPY/HKD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/HRK': {
    pair: 'JPY/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/HUF': {
    pair: 'JPY/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/IDR': {
    pair: 'JPY/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/ILS': {
    pair: 'JPY/ILS',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/INR': {
    pair: 'JPY/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/KES': {
    pair: 'JPY/KES',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/KRW': {
    pair: 'JPY/KRW',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'JPY/KWD': {
    pair: 'JPY/KWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/KZT': {
    pair: 'JPY/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/MAD': {
    pair: 'JPY/MAD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/MXN': {
    pair: 'JPY/MXN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/NGN': {
    pair: 'JPY/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/NOK': {
    pair: 'JPY/NOK',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/NZD': {
    pair: 'JPY/NZD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/PEN': {
    pair: 'JPY/PEN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/PHP': {
    pair: 'JPY/PHP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/PLN': {
    pair: 'JPY/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/QAR': {
    pair: 'JPY/QAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/RON': {
    pair: 'JPY/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/RSD': {
    pair: 'JPY/RSD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/RUB': {
    pair: 'JPY/RUB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/SAR': {
    pair: 'JPY/SAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/SEK': {
    pair: 'JPY/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/SGD': {
    pair: 'JPY/SGD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/THB': {
    pair: 'JPY/THB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/TND': {
    pair: 'JPY/TND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/TRY': {
    pair: 'JPY/TRY',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/TWD': {
    pair: 'JPY/TWD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'JPY/UAH': {
    pair: 'JPY/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/USD': {
    pair: 'JPY/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'JPY/VND': {
    pair: 'JPY/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'JPY/XAF': {
    pair: 'JPY/XAF',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'JPY/XOF': {
    pair: 'JPY/XOF',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'JPY/ZAR': {
    pair: 'JPY/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KES/AUD': {
    pair: 'KES/AUD',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'KES/EUR': {
    pair: 'KES/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'KES/GBP': {
    pair: 'KES/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KES/JPY': {
    pair: 'KES/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/AUD': {
    pair: 'KRW/AUD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/CAD': {
    pair: 'KRW/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/CHF': {
    pair: 'KRW/CHF',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/CNH': {
    pair: 'KRW/CNH',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/DKK': {
    pair: 'KRW/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/EUR': {
    pair: 'KRW/EUR',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/GBP': {
    pair: 'KRW/GBP',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/HUF': {
    pair: 'KRW/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/JPY': {
    pair: 'KRW/JPY',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/NOK': {
    pair: 'KRW/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/NZD': {
    pair: 'KRW/NZD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KRW/SEK': {
    pair: 'KRW/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KRW/USD': {
    pair: 'KRW/USD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'KWD/CAD': {
    pair: 'KWD/CAD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'KWD/CHF': {
    pair: 'KWD/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KWD/JPY': {
    pair: 'KWD/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KWD/USD': {
    pair: 'KWD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/AUD': {
    pair: 'KZT/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/CAD': {
    pair: 'KZT/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/CHF': {
    pair: 'KZT/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/DKK': {
    pair: 'KZT/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/EUR': {
    pair: 'KZT/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'KZT/GBP': {
    pair: 'KZT/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'KZT/HUF': {
    pair: 'KZT/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/JPY': {
    pair: 'KZT/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/NOK': {
    pair: 'KZT/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/NZD': {
    pair: 'KZT/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/RUB': {
    pair: 'KZT/RUB',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'KZT/SEK': {
    pair: 'KZT/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'KZT/USD': {
    pair: 'KZT/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'MAD/CHF': {
    pair: 'MAD/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MAD/EUR': {
    pair: 'MAD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MAD/GBP': {
    pair: 'MAD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MAD/JPY': {
    pair: 'MAD/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MAD/SEK': {
    pair: 'MAD/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'MAD/USD': {
    pair: 'MAD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MUR/EUR': {
    pair: 'MUR/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'MUR/USD': {
    pair: 'MUR/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'MXN/CAD': {
    pair: 'MXN/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/CHF': {
    pair: 'MXN/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/CNH': {
    pair: 'MXN/CNH',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'MXN/HKD': {
    pair: 'MXN/HKD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'MXN/EUR': {
    pair: 'MXN/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/JPY': {
    pair: 'MXN/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'MXN/PLN': {
    pair: 'MXN/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/TRY': {
    pair: 'MXN/TRY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/USD': {
    pair: 'MXN/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'MXN/ZAR': {
    pair: 'MXN/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/AUD': {
    pair: 'NGN/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/CAD': {
    pair: 'NGN/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/CHF': {
    pair: 'NGN/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/DKK': {
    pair: 'NGN/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/EUR': {
    pair: 'NGN/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/GBP': {
    pair: 'NGN/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/HUF': {
    pair: 'NGN/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/JPY': {
    pair: 'NGN/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/NOK': {
    pair: 'NGN/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/NZD': {
    pair: 'NGN/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/SEK': {
    pair: 'NGN/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NGN/USD': {
    pair: 'NGN/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/ARS': {
    pair: 'NOK/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/AUD': {
    pair: 'NOK/AUD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/BRL': {
    pair: 'NOK/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/CAD': {
    pair: 'NOK/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/CHF': {
    pair: 'NOK/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/CLP': {
    pair: 'NOK/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/CNH': {
    pair: 'NOK/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/CNY': {
    pair: 'NOK/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/COP': {
    pair: 'NOK/COP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/CZK': {
    pair: 'NOK/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/DKK': {
    pair: 'NOK/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/EGP': {
    pair: 'NOK/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/EUR': {
    pair: 'NOK/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/GBP': {
    pair: 'NOK/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/HKD': {
    pair: 'NOK/HKD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'NOK/HUF': {
    pair: 'NOK/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/IDR': {
    pair: 'NOK/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/INR': {
    pair: 'NOK/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/JPY': {
    pair: 'NOK/JPY',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NOK/KRW': {
    pair: 'NOK/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/KZT': {
    pair: 'NOK/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/NGN': {
    pair: 'NOK/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/NZD': {
    pair: 'NOK/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NOK/PEN': {
    pair: 'NOK/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/PHP': {
    pair: 'NOK/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/PLN': {
    pair: 'NOK/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/RUB': {
    pair: 'NOK/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/SEK': {
    pair: 'NOK/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NOK/SGD': {
    pair: 'NOK/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NOK/TRY': {
    pair: 'NOK/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/TWD': {
    pair: 'NOK/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/UAH': {
    pair: 'NOK/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NOK/USD': {
    pair: 'NOK/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'NOK/VND': {
    pair: 'NOK/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/ARS': {
    pair: 'NZD/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/AUD': {
    pair: 'NZD/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NZD/BRL': {
    pair: 'NZD/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/CAD': {
    pair: 'NZD/CAD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/CHF': {
    pair: 'NZD/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/CLP': {
    pair: 'NZD/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/CNH': {
    pair: 'NZD/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/CNY': {
    pair: 'NZD/CNY',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'NZD/COP': {
    pair: 'NZD/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'NZD/CZK': {
    pair: 'NZD/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/DKK': {
    pair: 'NZD/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/EGP': {
    pair: 'NZD/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/EUR': {
    pair: 'NZD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NZD/GBP': {
    pair: 'NZD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'NZD/HKD': {
    pair: 'NZD/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/HUF': {
    pair: 'NZD/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/IDR': {
    pair: 'NZD/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/ILS': {
    pair: 'NZD/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/INR': {
    pair: 'NZD/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/JPY': {
    pair: 'NZD/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'NZD/KRW': {
    pair: 'NZD/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'NZD/KZT': {
    pair: 'NZD/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/NGN': {
    pair: 'NZD/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/NOK': {
    pair: 'NZD/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/PEN': {
    pair: 'NZD/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/PHP': {
    pair: 'NZD/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/PLN': {
    pair: 'NZD/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/RON': {
    pair: 'NZD/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/RUB': {
    pair: 'NZD/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/SEK': {
    pair: 'NZD/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/SGD': {
    pair: 'NZD/SGD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/TRY': {
    pair: 'NZD/TRY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/TWD': {
    pair: 'NZD/TWD',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'NZD/UAH': {
    pair: 'NZD/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'NZD/USD': {
    pair: 'NZD/USD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'NZD/VND': {
    pair: 'NZD/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'OMR/EUR': {
    pair: 'OMR/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'OMR/USD': {
    pair: 'OMR/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/AUD': {
    pair: 'PEN/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/CAD': {
    pair: 'PEN/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/CHF': {
    pair: 'PEN/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/DKK': {
    pair: 'PEN/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/EUR': {
    pair: 'PEN/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/GBP': {
    pair: 'PEN/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/HUF': {
    pair: 'PEN/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/JPY': {
    pair: 'PEN/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PEN/NOK': {
    pair: 'PEN/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/NZD': {
    pair: 'PEN/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/SEK': {
    pair: 'PEN/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PEN/USD': {
    pair: 'PEN/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/AUD': {
    pair: 'PHP/AUD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'PHP/CAD': {
    pair: 'PHP/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/CHF': {
    pair: 'PHP/CHF',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'PHP/CNH': {
    pair: 'PHP/CNH',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'PHP/DKK': {
    pair: 'PHP/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/EUR': {
    pair: 'PHP/EUR',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'PHP/GBP': {
    pair: 'PHP/GBP',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'PHP/HUF': {
    pair: 'PHP/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/JPY': {
    pair: 'PHP/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PHP/NOK': {
    pair: 'PHP/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/NZD': {
    pair: 'PHP/NZD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'PHP/SEK': {
    pair: 'PHP/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PHP/USD': {
    pair: 'PHP/USD',
    precision: 8,
    isInverted: true,
    canOption: false,
  },
  'PLN/AED': {
    pair: 'PLN/AED',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/AUD': {
    pair: 'PLN/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/BGN': {
    pair: 'PLN/BGN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/CHF': {
    pair: 'PLN/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/CNH': {
    pair: 'PLN/CNH',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'PLN/CNY': {
    pair: 'PLN/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/CZK': {
    pair: 'PLN/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/DKK': {
    pair: 'PLN/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/EUR': {
    pair: 'PLN/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/GBP': {
    pair: 'PLN/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/HKD': {
    pair: 'PLN/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/HRK': {
    pair: 'PLN/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/HUF': {
    pair: 'PLN/HUF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'PLN/INR': {
    pair: 'PLN/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/ILS': {
    pair: 'PLN/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/JPY': {
    pair: 'PLN/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/MXN': {
    pair: 'PLN/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/RON': {
    pair: 'PLN/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/RUB': {
    pair: 'PLN/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/SEK': {
    pair: 'PLN/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/SGD': {
    pair: 'PLN/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'PLN/THB': {
    pair: 'PLN/THB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/TND': {
    pair: 'PLN/TND',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'PLN/TRY': {
    pair: 'PLN/TRY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/UAH': {
    pair: 'PLN/UAH',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'PLN/USD': {
    pair: 'PLN/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'PLN/ZAR': {
    pair: 'PLN/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'QAR/CHF': {
    pair: 'QAR/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'QAR/JPY': {
    pair: 'QAR/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'QAR/SAR': {
    pair: 'QAR/SAR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'QAR/SEK': {
    pair: 'QAR/SEK',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'QAR/USD': {
    pair: 'QAR/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/BGN': {
    pair: 'RON/BGN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/CAD': {
    pair: 'RON/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/CHF': {
    pair: 'RON/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/CNH': {
    pair: 'RON/CNH',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'RON/CZK': {
    pair: 'RON/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/EUR': {
    pair: 'RON/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/HUF': {
    pair: 'RON/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/JPY': {
    pair: 'RON/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/PLN': {
    pair: 'RON/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/NZD': {
    pair: 'RON/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/RUB': {
    pair: 'RON/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RON/USD': {
    pair: 'RON/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RON/ZAR': {
    pair: 'RON/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RSD/CHF': {
    pair: 'RSD/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RSD/JPY': {
    pair: 'RSD/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/AUD': {
    pair: 'RUB/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/CAD': {
    pair: 'RUB/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/CHF': {
    pair: 'RUB/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/CNH': {
    pair: 'RUB/CNH',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/CZK': {
    pair: 'RUB/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RUB/DKK': {
    pair: 'RUB/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/HKD': {
    pair: 'RUB/HKD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'RUB/EUR': {
    pair: 'RUB/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/GBP': {
    pair: 'RUB/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/HUF': {
    pair: 'RUB/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RUB/JPY': {
    pair: 'RUB/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RUB/KZT': {
    pair: 'RUB/KZT',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'RUB/NOK': {
    pair: 'RUB/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/NZD': {
    pair: 'RUB/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/PLN': {
    pair: 'RUB/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/RON': {
    pair: 'RUB/RON',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/SEK': {
    pair: 'RUB/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'RUB/TRY': {
    pair: 'RUB/TRY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/USD': {
    pair: 'RUB/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'RUB/ZAR': {
    pair: 'RUB/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SAR/AED': {
    pair: 'SAR/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SAR/CAD': {
    pair: 'SAR/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SAR/CHF': {
    pair: 'SAR/CHF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SAR/CNH': {
    pair: 'SAR/CNH',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'SAR/CZK': {
    pair: 'SAR/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SAR/EUR': {
    pair: 'SAR/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SAR/GBP': {
    pair: 'SAR/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SAR/JPY': {
    pair: 'SAR/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SAR/USD': {
    pair: 'SAR/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/AED': {
    pair: 'SEK/AED',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'SEK/ARS': {
    pair: 'SEK/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/AUD': {
    pair: 'SEK/AUD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/BRL': {
    pair: 'SEK/BRL',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/CAD': {
    pair: 'SEK/CAD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/CHF': {
    pair: 'SEK/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/CLP': {
    pair: 'SEK/CLP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/CNH': {
    pair: 'SEK/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/CNY': {
    pair: 'SEK/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/COP': {
    pair: 'SEK/COP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/CZK': {
    pair: 'SEK/CZK',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'SEK/DKK': {
    pair: 'SEK/DKK',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'SEK/EGP': {
    pair: 'SEK/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/EUR': {
    pair: 'SEK/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/GBP': {
    pair: 'SEK/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/HKD': {
    pair: 'SEK/HKD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'SEK/HUF': {
    pair: 'SEK/HUF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'SEK/IDR': {
    pair: 'SEK/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/INR': {
    pair: 'SEK/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/JPY': {
    pair: 'SEK/JPY',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'SEK/KRW': {
    pair: 'SEK/KRW',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/KZT': {
    pair: 'SEK/KZT',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/MAD': {
    pair: 'SEK/MAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/NGN': {
    pair: 'SEK/NGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/NOK': {
    pair: 'SEK/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/NZD': {
    pair: 'SEK/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/PEN': {
    pair: 'SEK/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/PHP': {
    pair: 'SEK/PHP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/PLN': {
    pair: 'SEK/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/QAR': {
    pair: 'SEK/QAR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'SEK/RON': {
    pair: 'SEK/RON',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/RUB': {
    pair: 'SEK/RUB',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/SGD': {
    pair: 'SEK/SGD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/THB': {
    pair: 'SEK/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/TRY': {
    pair: 'SEK/TRY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SEK/TWD': {
    pair: 'SEK/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/UAH': {
    pair: 'SEK/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/USD': {
    pair: 'SEK/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'SEK/VND': {
    pair: 'SEK/VND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SEK/ZAR': {
    pair: 'SEK/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/AED': {
    pair: 'SGD/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/AUD': {
    pair: 'SGD/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/CAD': {
    pair: 'SGD/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/CHF': {
    pair: 'SGD/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/CNH': {
    pair: 'SGD/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/CNY': {
    pair: 'SGD/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/CZK': {
    pair: 'SGD/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/DKK': {
    pair: 'SGD/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/EUR': {
    pair: 'SGD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/GBP': {
    pair: 'SGD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/HKD': {
    pair: 'SGD/HKD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/HUF': {
    pair: 'SGD/HUF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/IDR': {
    pair: 'SGD/IDR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/INR': {
    pair: 'SGD/INR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/JPY': {
    pair: 'SGD/JPY',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'SGD/KRW': {
    pair: 'SGD/KRW',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'SGD/NOK': {
    pair: 'SGD/NOK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/NZD': {
    pair: 'SGD/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/RUB': {
    pair: 'SGD/RUB',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'SGD/PHP': {
    pair: 'SGD/PHP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'SGD/PLN': {
    pair: 'SGD/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/SEK': {
    pair: 'SGD/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/THB': {
    pair: 'SGD/THB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/TWD': {
    pair: 'SGD/TWD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'SGD/USD': {
    pair: 'SGD/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'SGD/ZAR': {
    pair: 'SGD/ZAR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'THB/CAD': {
    pair: 'THB/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'THB/CHF': {
    pair: 'THB/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'THB/CNH': {
    pair: 'THB/CNH',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'THB/EUR': {
    pair: 'THB/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'THB/HKD': {
    pair: 'THB/HKD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'THB/IDR': {
    pair: 'THB/IDR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'THB/JPY': {
    pair: 'THB/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'THB/PLN': {
    pair: 'THB/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'THB/USD': {
    pair: 'THB/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'TND/CHF': {
    pair: 'TND/CHF',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TND/EUR': {
    pair: 'TND/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TND/GBP': {
    pair: 'TND/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TND/JPY': {
    pair: 'TND/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TND/PLN': {
    pair: 'TND/PLN',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'TND/USD': {
    pair: 'TND/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/AUD': {
    pair: 'TRY/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/CAD': {
    pair: 'TRY/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/CHF': {
    pair: 'TRY/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/CZK': {
    pair: 'TRY/CZK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TRY/DKK': {
    pair: 'TRY/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/EUR': {
    pair: 'TRY/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/GBP': {
    pair: 'TRY/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/HUF': {
    pair: 'TRY/HUF',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'TRY/ILS': {
    pair: 'TRY/ILS',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'TRY/JPY': {
    pair: 'TRY/JPY',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'TRY/MXN': {
    pair: 'TRY/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TRY/NOK': {
    pair: 'TRY/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/NZD': {
    pair: 'TRY/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/PLN': {
    pair: 'TRY/PLN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TRY/RUB': {
    pair: 'TRY/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TRY/SEK': {
    pair: 'TRY/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TRY/USD': {
    pair: 'TRY/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TRY/ZAR': {
    pair: 'TRY/ZAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TWD/AUD': {
    pair: 'TWD/AUD',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'TWD/CAD': {
    pair: 'TWD/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TWD/CHF': {
    pair: 'TWD/CHF',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'TWD/CNH': {
    pair: 'TWD/CNH',
    precision: 6,
    isInverted: true,
    canOption: false,
  },
  'TWD/DKK': {
    pair: 'TWD/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TWD/EUR': {
    pair: 'TWD/EUR',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'TWD/GBP': {
    pair: 'TWD/GBP',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'TWD/HKD': {
    pair: 'TWD/HKD',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'TWD/HUF': {
    pair: 'TWD/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TWD/JPY': {
    pair: 'TWD/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'TWD/NOK': {
    pair: 'TWD/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TWD/NZD': {
    pair: 'TWD/NZD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'TWD/SEK': {
    pair: 'TWD/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'TWD/USD': {
    pair: 'TWD/USD',
    precision: 7,
    isInverted: true,
    canOption: false,
  },
  'UAH/AUD': {
    pair: 'UAH/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/CAD': {
    pair: 'UAH/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/CHF': {
    pair: 'UAH/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/DKK': {
    pair: 'UAH/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/EUR': {
    pair: 'UAH/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/GBP': {
    pair: 'UAH/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/HUF': {
    pair: 'UAH/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/JPY': {
    pair: 'UAH/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/NOK': {
    pair: 'UAH/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/NZD': {
    pair: 'UAH/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/PLN': {
    pair: 'UAH/PLN',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'UAH/SEK': {
    pair: 'UAH/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'UAH/USD': {
    pair: 'UAH/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'USD/AED': {
    pair: 'USD/AED',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/ARS': {
    pair: 'USD/ARS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/AUD': {
    pair: 'USD/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'USD/BGN': {
    pair: 'USD/BGN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/BHD': {
    pair: 'USD/BHD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'USD/BRL': {
    pair: 'USD/BRL',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/BWP': {
    pair: 'USD/BWP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/CAD': {
    pair: 'USD/CAD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/CHF': {
    pair: 'USD/CHF',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/CLP': {
    pair: 'USD/CLP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/CNH': {
    pair: 'USD/CNH',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/CNY': {
    pair: 'USD/CNY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/COP': {
    pair: 'USD/COP',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/CZK': {
    pair: 'USD/CZK',
    precision: 4,
    isInverted: false,
    canOption: true,
  },
  'USD/DKK': {
    pair: 'USD/DKK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/DZD': {
    pair: 'USD/DZD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/EGP': {
    pair: 'USD/EGP',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/EUR': {
    pair: 'USD/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'USD/GBP': {
    pair: 'USD/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'USD/GHS': {
    pair: 'USD/GHS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/HKD': {
    pair: 'USD/HKD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/HRK': {
    pair: 'USD/HRK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/HUF': {
    pair: 'USD/HUF',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/IDR': {
    pair: 'USD/IDR',
    precision: 1,
    isInverted: false,
    canOption: true,
  },
  'USD/ILS': {
    pair: 'USD/ILS',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/INR': {
    pair: 'USD/INR',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/ISK': {
    pair: 'USD/ISK',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/JOD': {
    pair: 'USD/JOD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/JPY': {
    pair: 'USD/JPY',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/KES': {
    pair: 'USD/KES',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/KRW': {
    pair: 'USD/KRW',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/KWD': {
    pair: 'USD/KWD',
    precision: 6,
    isInverted: false,
    canOption: false,
  },
  'USD/KZT': {
    pair: 'USD/KZT',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/MAD': {
    pair: 'USD/MAD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/MUR': {
    pair: 'USD/MUR',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/MXN': {
    pair: 'USD/MXN',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/MZN': {
    pair: 'USD/MZN',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'USD/NGN': {
    pair: 'USD/NGN',
    precision: 3,
    isInverted: false,
    canOption: false,
  },
  'USD/NOK': {
    pair: 'USD/NOK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/NZD': {
    pair: 'USD/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'USD/OMR': {
    pair: 'USD/OMR',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'USD/PEN': {
    pair: 'USD/PEN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/PHP': {
    pair: 'USD/PHP',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/PLN': {
    pair: 'USD/PLN',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/QAR': {
    pair: 'USD/QAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/RON': {
    pair: 'USD/RON',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/RSD': {
    pair: 'USD/RSD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'USD/RUB': {
    pair: 'USD/RUB',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/SAR': {
    pair: 'USD/SAR',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/SEK': {
    pair: 'USD/SEK',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/SGD': {
    pair: 'USD/SGD',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/THB': {
    pair: 'USD/THB',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'USD/TND': {
    pair: 'USD/TND',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/TRY': {
    pair: 'USD/TRY',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/TWD': {
    pair: 'USD/TWD',
    precision: 4,
    isInverted: false,
    canOption: true,
  },
  'USD/UAH': {
    pair: 'USD/UAH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'USD/UGX': {
    pair: 'USD/UGX',
    precision: 1,
    isInverted: true,
    canOption: false,
  },
  'USD/UZS': {
    pair: 'USD/UZS',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'USD/VND': {
    pair: 'USD/VND',
    precision: 1,
    isInverted: false,
    canOption: false,
  },
  'USD/XAF': {
    pair: 'USD/XAF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'USD/XOF': {
    pair: 'USD/XOF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'USD/ZAR': {
    pair: 'USD/ZAR',
    precision: 5,
    isInverted: false,
    canOption: true,
  },
  'USD/ZMW': {
    pair: 'USD/ZMW',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'UZS/USD': {
    pair: 'UZS/USD',
    precision: 4,
    isInverted: true,
    canOption: false,
  },
  'VND/AUD': {
    pair: 'VND/AUD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/CAD': {
    pair: 'VND/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/CHF': {
    pair: 'VND/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/DKK': {
    pair: 'VND/DKK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/EUR': {
    pair: 'VND/EUR',
    precision: 9,
    isInverted: true,
    canOption: false,
  },
  'VND/GBP': {
    pair: 'VND/GBP',
    precision: 9,
    isInverted: true,
    canOption: false,
  },
  'VND/HUF': {
    pair: 'VND/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/JPY': {
    pair: 'VND/JPY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/NOK': {
    pair: 'VND/NOK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/NZD': {
    pair: 'VND/NZD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/SEK': {
    pair: 'VND/SEK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'VND/USD': {
    pair: 'VND/USD',
    precision: 9,
    isInverted: true,
    canOption: false,
  },
  'XAG/AUD': {
    pair: 'XAG/AUD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAG/CHF': {
    pair: 'XAG/CHF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAG/EUR': {
    pair: 'XAG/EUR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAG/GBP': {
    pair: 'XAG/GBP',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAG/JPY': {
    pair: 'XAG/JPY',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAG/USD': {
    pair: 'XAG/USD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XAU/AUD': {
    pair: 'XAU/AUD',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XAU/CHF': {
    pair: 'XAU/CHF',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XAU/EUR': {
    pair: 'XAU/EUR',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XAU/GBP': {
    pair: 'XAU/GBP',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XAU/JPY': {
    pair: 'XAU/JPY',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XAU/USD': {
    pair: 'XAU/USD',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XPD/AUD': {
    pair: 'XPD/AUD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPD/CHF': {
    pair: 'XPD/CHF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPD/EUR': {
    pair: 'XPD/EUR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPD/GBP': {
    pair: 'XPD/GBP',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPD/JPY': {
    pair: 'XPD/JPY',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPD/USD': {
    pair: 'XPD/USD',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'XPT/AUD': {
    pair: 'XPT/AUD',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPT/CHF': {
    pair: 'XPT/CHF',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPT/EUR': {
    pair: 'XPT/EUR',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPT/GBP': {
    pair: 'XPT/GBP',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPT/JPY': {
    pair: 'XPT/JPY',
    precision: 4,
    isInverted: false,
    canOption: false,
  },
  'XPT/USD': {
    pair: 'XPT/USD',
    precision: 2,
    isInverted: false,
    canOption: false,
  },
  'ZAR/CAD': {
    pair: 'ZAR/CAD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/CHF': {
    pair: 'ZAR/CHF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/CNH': {
    pair: 'ZAR/CNH',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/CZK': {
    pair: 'ZAR/CZK',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/EUR': {
    pair: 'ZAR/EUR',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/GBP': {
    pair: 'ZAR/GBP',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/HUF': {
    pair: 'ZAR/HUF',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/INR': {
    pair: 'ZAR/INR',
    precision: 3,
    isInverted: false,
    canOption: true,
  },
  'ZAR/JPY': {
    pair: 'ZAR/JPY',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/MXN': {
    pair: 'ZAR/MXN',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/PLN': {
    pair: 'ZAR/PLN',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/RON': {
    pair: 'ZAR/RON',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/RUB': {
    pair: 'ZAR/RUB',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/SEK': {
    pair: 'ZAR/SEK',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/SGD': {
    pair: 'ZAR/SGD',
    precision: 5,
    isInverted: false,
    canOption: false,
  },
  'ZAR/TRY': {
    pair: 'ZAR/TRY',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
  'ZAR/USD': {
    pair: 'ZAR/USD',
    precision: 5,
    isInverted: true,
    canOption: false,
  },
};
